exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-static-site-js": () => import("./../../../src/templates/static-site.js" /* webpackChunkName: "component---src-templates-static-site-js" */)
}

